type TableProps = {
  table: any;
  noBorder?: boolean;
  margin?: string;
  tableTitle?: string;
  width?: string;
};

const Table = ({ table, noBorder, margin, tableTitle, width }: TableProps) => {
  return (
    <div className="table-wrapper">
      <table id="denda">
        {tableTitle && (
          <thead>
            <tr>
              <th
                className="heading-title"
                colSpan={table.col}
                dangerouslySetInnerHTML={{ __html: tableTitle }}
              />
            </tr>
          </thead>
        )}
        <tr className="head">
          {table.heading.map((data, key) => {
            return (
              <th key={key + data} dangerouslySetInnerHTML={{ __html: data }} />
            );
          })}
        </tr>
        {table.content.map((data, key) => {
          return (
            <tr key={key + data}>
              {data.items.map((data) => {
                return (
                  <td
                    key={key + data}
                    className={
                      key === table.content.length - 1 ? "border-radius" : ""
                    }
                  >
                    {data}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </table>
      <style jsx>
        {`
          .heading-title {
            background-color: var(--color-red);
            color: var(--color-white);
          }
          th {
            background-color: var(--color-white);
            color: var(--color-red);
            font-size: 12px;
            height: 48px;
            padding: 0 16px;
          }
          th:nth-child(1) {
            border-radius: ${noBorder ? "0px" : "10px 0 0 0px"};
          }
          th:nth-last-child(1) {
            border-radius: ${noBorder ? "0px" : "10px 10px 0 0"};
          }

          .border-radius {
            border-bottom-right-radius: 10px;
          }

          table {
            box-shadow: 0 4px 8px 4px rgba(64, 64, 64, 0.2);
            border-radius: ${noBorder ? "0px" : "10px"};
            border-collapse: collapse;
            margin: ${margin ? margin : "16px"};
            overflow: hidden;
            max-width: ${width ? width : "auto"};
            width: ${width ? "100%" : "auto"};
            text-align: center;
          }

          td {
            padding: 16px;
          }
          .table-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          td:nth-child(even) {
            background-color: var(--color-white-soft);
          }
          .head {
            border-bottom: solid 2px var(--color-red);
          }
          @media only screen and (max-width: 600px) {
            table {
              font-size: 10px;
              max-width: 500px;
              width: 100%;
              overflow: auto;
            }
            .table-wrapper {
              margin: 0 16px;
            }
            th {
              width: 50%;
              font-size: 10px;
            }
            .head {
              grid-column: 1 / 2;
              border-bottom: solid 1px var(--color-red);
            }
            td {
              padding: 2px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Table;
